import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
 
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true               
};
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'; 

import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { AppSettings } from './app.settings';

import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ProduitComponent } from './produit/produit.component';
import { AddProduitComponent } from './add-produit/add-produit.component';
import { DeleteProduitComponent } from './delete-produit/delete-produit.component';
import { AllProduitComponent } from './pages/all-produit/all-produit.component';
import { AllCategorieComponent } from './pages/all-categorie/all-categorie.component';
import { AddCategorieComponent } from './add-categorie/add-categorie.component';
import { DeleteCategorieComponent } from './delete-categorie/delete-categorie.component';
import { UpdateCategorieComponent } from './update-categorie/update-categorie.component';
import { LoginComponent } from './login/login.component';
import { UpdateProduitComponent } from './update-produit/update-produit.component';
import { ZoneComponent } from './pages/zone/zone.component';
import { AddZoneComponent } from './add-zone/add-zone.component';
import { DeleteZoneComponent } from './delete-zone/delete-zone.component';
import { UpdateZoneComponent } from './update-zone/update-zone.component';
import { AddPlageComponent } from './add-plage/add-plage.component';
import { ViewPlageComponent } from './view-plage/view-plage.component';
import { DeletePlageComponent } from './delete-plage/delete-plage.component';
import { AllStockComponent } from './pages/all-stock/all-stock.component';
import { AddStockComponent } from './add-stock/add-stock.component';
import { UpdateStockComponent } from './update-stock/update-stock.component';
import { DeleteStockComponent } from './delete-stock/delete-stock.component';
import { AllChauffeurComponent } from './pages/all-chauffeur/all-chauffeur.component';
import { AddChauffeurComponent } from './add-chauffeur/add-chauffeur.component';
import { DeleteChauffeurComponent } from './delete-chauffeur/delete-chauffeur.component';
import { UpdateChauffeurComponent } from './update-chauffeur/update-chauffeur.component';
import { TransportComponent } from './transport/transport.component';
import { AddTransportComponent } from './add-transport/add-transport.component';
import { DeleteTransportComponent } from './delete-transport/delete-transport.component';
import { CamionComponent } from './pages/camion/camion.component';
import { AddCamionComponent } from './add-camion/add-camion.component';
import { UpdateCamionComponent } from './update-camion/update-camion.component';
import { DeleteCamionComponent } from './delete-camion/delete-camion.component';
import { TransportsComponent } from './transports/transports.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,     
    FormsModule, 
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAO7Mg2Cs1qzo_3jkKkZAKY6jtwIlm41-I'
    }), 
    PerfectScrollbarModule, 
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    HttpClientModule,
    SharedModule,
    PipesModule,
    AppRoutingModule,
    
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    BlankComponent,
    SearchComponent,
    NotFoundComponent,
    ErrorComponent,
    SidenavComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    FlagsMenuComponent,
    FullScreenComponent,
    ApplicationsComponent,
    MessagesComponent,
    UserMenuComponent,
    ProduitComponent,
    AddProduitComponent,
    DeleteProduitComponent,
    AllProduitComponent,
    AllCategorieComponent,
    AddCategorieComponent,
    UpdateCategorieComponent,
    DeleteCategorieComponent,
    UpdateProduitComponent,
    LoginComponent,
    ZoneComponent,
    AddZoneComponent,
    DeleteZoneComponent,
    UpdateZoneComponent,
    AddPlageComponent,
    ViewPlageComponent,
    DeletePlageComponent,
    AllStockComponent,
    AddStockComponent,
    UpdateStockComponent,
    DeleteStockComponent,
    AllChauffeurComponent,
    AddChauffeurComponent,
    DeleteChauffeurComponent,
    UpdateChauffeurComponent,
    TransportComponent,
    AddTransportComponent,
    DeleteTransportComponent,
    CamionComponent,
    AddCamionComponent,
    UpdateCamionComponent,
    DeleteCamionComponent,
    TransportsComponent,
    
  ],
  providers: [ 
    AppSettings,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }